const _ = require('underscore');
const config = require('core/config');
const utilities = require('utilities');
const model = require('model/model');
const cloneDeep = utilities.cloneDeep;

let metadata = window.readworks.metadata;

const TEXT_TYPE_ID = 11;
const GRADES_ID = 15;
const DOMAIN_ID = 173;
const SKILLS_ID = 1;
const ROLES_ID = 377;
const PARTNERS_ID = 404;
const STAFF_PICKS_ID = 191935;
const SOCIAL_EMOTIONAL_ID = 191947;
const SOCIAL_STUDIES_ID = 372;
const SCIENCE_ID = 373;
const LITERARY_ID = 374;
const SKF_ID = 500;
const GENRE_ID = 600;
const PROMOTIONAL_ID = 888888;
const ARTS_ID = 191993;
const BOOKS_ID = 'books';
const SERIES_ID = 800;
const CURRICULUM_ID = 192139;
const SSO_SYSTEMS_ID = 192130;

const PARENT_WHITELIST = {
	[SKILLS_ID]: {
		id: SKILLS_ID,
		filterKey: 'k',
		order: 4,
		allowParentFilter: true
	},
	[SOCIAL_STUDIES_ID]: {
		id: SOCIAL_STUDIES_ID,
		filterKey: 's',
		order: 2,
		allowParentFilter: true
	},
	[SCIENCE_ID]: {
		id: SCIENCE_ID,
		filterKey: 's',
		order: 1,
		allowParentFilter: true
	},
	[LITERARY_ID]: {
		id: LITERARY_ID,
		filterKey: 's',
		order: 3,
		allowParentFilter: true
	},
	[PARTNERS_ID]: {
		id: PARTNERS_ID,
		filterKey: 'cid',
		order: 8,
		allowParentFilter: false,
		filter: node => {
			return node.is_special_collection;
		}
	},
	[STAFF_PICKS_ID]: {
		id: STAFF_PICKS_ID,
		filterKey: 'staff_picks',
		order: 6,
		allowParentFilter: true
	},
	[SOCIAL_EMOTIONAL_ID]: {
		id: SOCIAL_EMOTIONAL_ID,
		filterKey: 'sel',
		order: 5,
		allowParentFilter: true
	},
	[ARTS_ID]: {
		id: ARTS_ID,
		filterKey: 's',
		order: 8,
		allowParentFilter: true
	},
	[SERIES_ID]: {
		id: SERIES_ID,
		filterKey: 'series',
		order: 7,
		allowParentFilter: true
	}
};

const TOPICS_LIST = {
	[SOCIAL_STUDIES_ID]: PARENT_WHITELIST[SOCIAL_STUDIES_ID],
	[SCIENCE_ID]: PARENT_WHITELIST[SCIENCE_ID],
	[ARTS_ID]: PARENT_WHITELIST[ARTS_ID]
};

const SPECIAL_COLLECTIONS_LIST = {
	[PARTNERS_ID]: PARENT_WHITELIST[PARTNERS_ID],
	[STAFF_PICKS_ID]: PARENT_WHITELIST[STAFF_PICKS_ID],
	[SOCIAL_EMOTIONAL_ID]: PARENT_WHITELIST[SOCIAL_EMOTIONAL_ID],
	[SERIES_ID]: PARENT_WHITELIST[SERIES_ID]
};

const PROMOTIONAL_COLLECTIONS = {
	888888: {
		children: [
			{
				id: 888889,
				order: 1,
				imgUrl: '/assets/dist/images/luke-kornet-2.jpg',
				thumbnailUrl: '/assets/dist/images/luke-kornet-2-thumb.jpg',
				description:
					'"I love to read to be able to learn more about things I\'m interested in, as well as to discover new ways that I can improve myself, whether it be physically, mentally, emotionally or spiritually. Lately I\'ve been reading a lot about health and sports and in particular how the two are related. Who knew that sleep could be such a huge factor in sports performance, mental focus, and even what kinds of foods you want to eat? Read on to see what I think is really interesting."<p>Luke Kornet, Professional Basketball Player</p>',
				name: 'Luke Kornet’s Reading List',
				subtitle: 'Health & Sports',
				featuredProducts: ['ec823baa-8107-41c7-8da6-b32ffc8f81f2', '6b4042b3-d433-43c9-bbf5-d51cc958735c'],
				products: [
					'14b03cb6-08c8-4390-a73a-9fab0c2af2f2',
					'8c3fb032-6686-4be2-8197-a6c861351d7b',
					'c70c756d-cf09-4b7d-862e-9a92003334d2',
					'b79ce966-97a0-4ede-a7c1-6483523e0d6c',
					'9bf785e1-ec73-48b8-810c-b49c58225e33',
					'a975cc74-7204-4cb3-a6fc-63385afb2def',
					'225dc75a-b7ba-4d0d-a5fb-25a0f90c186e',
					'f3e6fc88-db6f-46de-a6f2-5c1c7107e628',
					'6b4042b3-d433-43c9-bbf5-d51cc958735c',
					'e256ed50-9c76-4f86-b4d3-2c49593add41',
					'ec823baa-8107-41c7-8da6-b32ffc8f81f2',
					'9854ec3d-5be5-492a-bee9-ae5d777ec398'
				]
			},
			{
				id: 888890,
				order: 2,
				imgUrl: '/assets/dist/images/marvin-williams.jpg',
				thumbnailUrl: '/assets/dist/images/marvin-williams-thumb.jpg',
				description:
					'"I love reading about athletes and academics. I think education is as important as the sport you are passionate about. That\'s why I wanted to share these reading passages about athletes with inspiring stories"<p>Marvin Williams, Professional Basketball Player</p>',
				name: "Marvin Williams' Reading List",
				subtitle: 'Inspiring Athletes',
				featuredProducts: ['b52bcb43-2bb0-4578-9838-2e7264c74a38', 'd5f5f826-a817-45e7-a5e1-fd46e6d0018c'],
				products: [
					'93d47d0b-61dc-4eec-8465-43ff6bdcfd9b',
					'b79ce966-97a0-4ede-a7c1-6483523e0d6c',
					'0403ff96-9264-482e-8e81-f5e67a2f83c4',
					'f6005802-4e42-4b37-8b8a-054993c7a372',
					'1e227ccc-5ef6-41ae-ae0c-d0477dce1fa3',
					'd5f5f826-a817-45e7-a5e1-fd46e6d0018c',
					'e20e3ab7-d430-43df-b37e-3b65d015426e',
					'0f0fbe0f-3b9c-4641-b122-23b09126b312',
					'b52bcb43-2bb0-4578-9838-2e7264c74a38',
					'2607f4c0-45f8-411e-b721-62e0148365e4',
					'bba9a32f-49b9-4d5e-ad25-2718308fb885',
					'bd38de05-6d83-445e-a50a-d6eefbf1f906'
				]
			}
		],
		id: 888888,
		name: 'Promotional Collections',
		order: 99
	}
};

const mkIdLookUp = (node, includeInactive = true) => {
	if (!node || !node.children || !node.children.length || node.active === false) {
		return void 0;
	}

	let byId = {};
	let scan = [...node.children];

	while (scan.length) {
		let currentNode = scan.shift();
		let lookupKey = node.id === 'book' ? '_book_' + currentNode.id : '_' + currentNode.id;

		if (includeInactive || currentNode.active !== false) {
			// ensure direct parentId
			byId[lookupKey] = _.assign({}, currentNode, {
				parentId: currentNode.parentId || node.id,
				parentName: currentNode.parentName || node.name
			});

			// Add nodes to stack to allow for more n levels of children
			if (currentNode.children && currentNode.children.length) {
				currentNode.children.forEach(child => {
					scan.push(
						_.assign({}, child, {
							parentId: currentNode.id,
							parentName: currentNode.name
						})
					);
				});
			}
		}
	}

	return byId;
};

// Remove inactive children from a node
const trimInactive = node => {
	if (!node || node.active === false) {
		return null;
	}

	let trimmedNode = node;

	if (node.children && node.children.length) {
		trimmedNode = _.assign({}, node);
		let trimmedChildren = [];
		node.children.forEach(child => {
			let trimmed = trimInactive(child);
			if (trimmed) {
				trimmedChildren.push(trimmed);
			}
		});
		trimmedNode.children = trimmedChildren;
	}

	return trimmedNode;
};

/**
 * Fix Special Collection IDs and imgUrl's. The child nodes of special collections have IDs
 * that may conflict with IDs elsewhere in the metadata tree. So we prepend a 'c' onto
 * children of the node, recursively. The node is cloned, not modified in-place. Also the imgUrl
 * property has the server config S3_BUCKET_ENDPOINT value pre-pended so that the
 * imgUrl may be used directly in the UI.
 *
 * @param  {object} node The special collections node from the server
 * @return {object}      A new node with children's IDs and imgUrl's adjusted
 */
const adjustSpecialCollectionsNodes = node => {
	var node2 = cloneDeep(node);
	node2.children = [];

	var imageTypes = ['imgUrl', 'imageUrlS', 'imageUrlM', 'imageUrlL'];
	var sizeRegex = /.*(S|M|L)-(\d+)x(\d+)\.(gif|png|jpg|jpeg)$/;

	// prepend the image URLs with their endpoint and set width/height attributes if available
	if (node.children) {
		node.children.forEach(c => {
			var c2 = cloneDeep(c);
			imageTypes.forEach(it => {
				if (c2[it]) {
					c2[it] = (config.resources.media.cdn || config.resources.media.origin) + '/' + c2[it];
					var m = sizeRegex.exec(c2[it]);
					if (m) {
						c2[it + 'Width'] = m[2];
						c2[it + 'Height'] = m[3];
					}
				}
			});
			node2.children.push(adjustSpecialCollectionsNodes(c2));
		});
	}
	return node2;
};

const sortByOrder = (a, b) => {
	return +(a.order > b.order) || +(a.order === b.order) - 1;
};

const prepare = d => {
	const books = d.books || [];

	let d2 = {
		whatsNew: d.whatsNew,
		visitorPopup: d.visitorPopup,
		featuredTopics: d.featuredTopics,
		scopeAndSequence: d.scope_and_sequence,
		promoNewsItems: d.promo_news_items,
		decodableLetterSounds: d.decodable_teacher_edition_letter_sounds || {},
		homepagePanels: d.page_panels || [],
		books
	};
	let gradesNode;
	const searchableNodeTypes = {
		[TEXT_TYPE_ID]: true,
		[DOMAIN_ID]: true,
		[PARTNERS_ID]: true,
		[STAFF_PICKS_ID]: true,
		[SOCIAL_EMOTIONAL_ID]: true,
		[ARTS_ID]: true,
		[SERIES_ID]: true
	};

	if (!model.get('gcAddon')) {
		searchableNodeTypes[BOOKS_ID] = true;
	}

	let searchableNodes = [];

	d2.allActiveNodesById = {};
	d2.allNodesById = {};

	d = _.assign({}, d, PROMOTIONAL_COLLECTIONS);

	_.each(d, (node, nodeKey) => {
		if (node.id == PARTNERS_ID) {
			node = adjustSpecialCollectionsNodes(node);
		}

		if (nodeKey === BOOKS_ID) {
			node = {
				id: 'book',
				name: 'Book Title',
				children: books.map(book => ({ name: book.title, id: book.id }))
			};
		}

		// Include inactive
		d2.allNodesById['_' + node.id] = node;
		let allNodesIdLookup = mkIdLookUp(node);
		_.assign(d2.allNodesById, allNodesIdLookup);

		// Only active
		if (node.active !== false) {
			// trim inactive children before adding to active node list
			node = trimInactive(node);
			d2.allActiveNodesById['_' + node.id] = node;
			let idLookup = mkIdLookUp(node, false);
			_.assign(d2.allActiveNodesById, idLookup);

			switch (node.id) {
				case PARTNERS_ID:
					// Create partners node
					node.children.sort(sortByOrder);
					d2.partnersNode = cloneDeep(node);

					// Filter out non-sc partners to create SC node
					let scNode = _.assign({}, cloneDeep(node));
					let scChildren = node.children.filter(c => c.is_special_collection);
					scNode.children = scChildren;
					d2.specialCollectionsNode = scNode;
					break;
				case GRADES_ID:
					gradesNode = node;
					break;
				case DOMAIN_ID:
					d2.domainsById = cloneDeep(idLookup);
					d2.domainNode = node;
					d2.topDomains = cloneDeep(node).children;
					break;
				case ROLES_ID:
					d2.rolesById = cloneDeep(idLookup);
					d2.roles = node.children
						.map(c => {
							return {
								text: c.name,
								order: c.order,
								value: c.id
							};
						})
						.sort(sortByOrder);
					break;
				case TEXT_TYPE_ID:
					d2.textTypeById = cloneDeep(idLookup);
					d2.textTypes = (node.children || []).map(tt => {
						return {
							id: tt.id,
							value: tt.id,
							text: tt.name,
							order: tt.order
						};
					});
					break;
				case SKILLS_ID:
					d2.skillsById = cloneDeep(idLookup);
					d2.skillsNode = node;
					break;
				case STAFF_PICKS_ID:
					d2.staffPicksById = cloneDeep(idLookup);
					d2.staffPicksNode = node;
					d2.staffPicks = (node.children || [])
						.map(sp => {
							return {
								id: sp.id,
								value: sp.id,
								text: sp.name,
								order: sp.order
							};
						})
						.sort(sortByOrder);
					break;
				case SOCIAL_EMOTIONAL_ID:
					d2.socialEmotionalById = cloneDeep(idLookup);
					d2.socialEmotionalNode = node;
					d2.socialEmotional = (node.children || [])
						.map(sel => {
							return {
								id: sel.id,
								value: sel.id,
								text: sel.name,
								order: sel.order
							};
						})
						.sort(sortByOrder);
					break;
				case GENRE_ID:
					d2.genresById = cloneDeep(idLookup);
					d2.genresNode = node;
					d2.genres = node.children || [];
					break;
				case SKF_ID:
					d2.skfById = cloneDeep(idLookup);
					d2.skfNode = node;
					d2.skf = node.children || [];
					break;
				case PROMOTIONAL_ID:
					d2.promotionalById = cloneDeep(idLookup);
					d2.promotionalNode = node;
					d2.promotional = node.children || [];
					break;
				case CURRICULUM_ID:
					d2.curriculumById = cloneDeep(idLookup);
					d2.curriculumNode = node;
					d2.curriculum =
						node.children
							?.map(c => ({
								...c,
								text: c.name
							}))
							.sort(sortByOrder) ?? [];
					break;
				case SSO_SYSTEMS_ID:
					d2.ssoSystemsById = cloneDeep(idLookup);
					d2.ssoSystemsNode = node;
					d2.ssoSystems =
						node.children
							?.map(sso => ({
								...sso,
								text: sso.name
							}))
							.sort(sortByOrder) ?? [];
					break;
			}

			if (searchableNodeTypes[node.id] || (searchableNodeTypes[nodeKey] && idLookup)) {
				let tempSearchNodes = cloneDeep(idLookup);

				if (node.id === PARTNERS_ID) {
					tempSearchNodes = mkIdLookUp(d2.specialCollectionsNode);
				}

				if (node.id !== DOMAIN_ID && node.id !== PARTNERS_ID) {
					searchableNodes.push(
						_.assign({}, node, {
							children: undefined,
							parentName: 'Topic'
						})
					);
				}

				if (tempSearchNodes) {
					let tempSearchNodesKeys = Object.keys(tempSearchNodes);
					if (tempSearchNodesKeys && tempSearchNodesKeys.length) {
						tempSearchNodesKeys.forEach(key => {
							// Clear children to make search list flat
							delete tempSearchNodes[key].children;
							searchableNodes.push(tempSearchNodes[key]);
						});
					}
				}
			}
		}
	});

	if (gradesNode && gradesNode.children) {
		let gs = [];
		let gById = {};

		gradesNode.children.sort(sortByOrder);

		gradesNode.children.forEach(c => {
			gById['_' + c.id] = {
				id: c.id,
				text: c.name,
				order: c.order
			};
			gs.push({
				id: c.id,
				selected: false,
				text: c.name,
				has_products: c.has_products
			});
		});

		d2.gradesById = gById;
		d2.gradeSelections = gs;
		d2.gradeSelectionsWithProducts = gs.filter(g => g.has_products);

		//Library Grade Map for Luke Kornet / Promotional Collection
		// TODO - replace with services
		d2.libraryGradeMap = d2.gradeSelections.reduce((acc, g, i, grades) => {
			acc[g.id] = {
				[g.id]: true
			};

			for (var c = i - 1; c >= 0; c--) {
				acc[g.id][grades[c].id] = true;
			}

			if (grades[i + 1]) {
				acc[g.id][grades[i + 1].id] = true;
			}

			if (grades[i + 2]) {
				acc[g.id][grades[i + 2].id] = true;
			}

			return acc;
		}, {});
	} else {
		d2.gradesById = {};
		d2.gradeSelections = [];
		d2.gradeSelectionsWithProducts = [];
	}

	d2.searchableNodes = searchableNodes;

	// Promotional collection switch
	// d2.promoId = 888890;

	return d2;
};

metadata = prepare(metadata);
metadata.prepare = prepare;
metadata.PARENT_WHITELIST = PARENT_WHITELIST;
metadata.sortByOrder = sortByOrder;
metadata.TOPICS_LIST = TOPICS_LIST;
metadata.SPECIAL_COLLECTIONS_LIST = SPECIAL_COLLECTIONS_LIST;

module.exports = metadata;
